import { Roles } from "@/models/user/roles";

export type GlobalState = {
  isLoading: boolean;
  isLoggedIn: boolean;
  userRole: Roles | null;
};

export type GlobalContext = {
  state: GlobalState;
  dispatch: (action: GlobalActions, payload?: any) => any;
  commit: (mutation: GlobalMutations, payload: any) => any;
};

export enum GlobalMutations {
  SetLoading = "setLoading",
  SetLoggedIn = "setLoggedIn",
  SetRole = "setRole"
}

export enum GlobalActions {
  AddLoading = "addLoading",
  AddLoggedIn = "addLoggedIn",
  AddRole = "addRole"
}

export enum GlobalGetters {
  GetLoading = "getLoading",
  GetLoggedIn = "getLoggedIn",
  GetRole = "getRole"
}
